/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2TeamsMembersByTeamIdAndUserIdParams,
  DeleteV2TeamsMembersByTeamIdAndUserIdParams,
  PostV2TeamsInviteByTeamIdParams,
  PostV2TeamsInvitationsResendByTeamIdAndInvitationIdParams,
  PostV2TeamsInviteAcceptPanelByInvitationIdParams,
  PostV2TeamsInviteAcceptEmailByTokenParams,
  PatchV2TeamsSettingsByTeamIdParams,
  PatchV2TeamsMembersRolesByTeamIdParams,
  GetV2TeamsByTeamIdParams,
  GetV2TeamsSubscriptionInfoByTeamIdParams,
  GetV2TeamsMembersByTeamIdParams,
  GetV2TeamsInvitationsByTeamIdParams,
  GetV2TeamsInviteValidateByTokenParams,
  DeleteV2TeamsByTeamIdAndEmailParams,
  DeleteV2TeamsInvitationsByTeamIdAndInvitationIdParams,
  PostV2TeamsBody,
  PostV2TeamsInviteByTeamIdBody,
  PatchV2TeamsSettingsByTeamIdBody,
  PatchV2TeamsMembersRolesByTeamIdBody,
  GetV2TeamsResponse,
  PostV2TeamsResponse,
  PostV2TeamsMembersByTeamIdAndUserIdResponse,
  PostV2TeamsInviteByTeamIdResponse,
  PatchV2TeamsSettingsByTeamIdResponse,
  PatchV2TeamsMembersRolesByTeamIdResponse,
  GetV2TeamsByTeamIdResponse,
  GetV2TeamsSubscriptionInfoByTeamIdResponse,
  GetV2TeamsMembersByTeamIdResponse,
  GetV2TeamsInvitationsByTeamIdResponse,
  GetV2TeamsInvitedResponse,
  GetV2TeamsInviteValidateByTokenResponse,
} from '../types';

export class TeamController extends Controller {
  async getV2Teams<T extends GetV2TeamsResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/teams',
      axiosConfig
    );
  }

  async postV2Teams<
    T extends PostV2TeamsResponse,
    D,
    C extends PostV2TeamsBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/teams',
      body,
      axiosConfig
    );
  }

  async postV2TeamsMembersByTeamIdAndUserId<
    T extends PostV2TeamsMembersByTeamIdAndUserIdResponse,
    D,
    C extends null
  >(
    body: C,
    { teamId, userId }: PostV2TeamsMembersByTeamIdAndUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/members/${userId}`,
      body,
      axiosConfig
    );
  }

  async deleteV2TeamsMembersByTeamIdAndUserId<T, D, C extends null>(
    { teamId, userId }: DeleteV2TeamsMembersByTeamIdAndUserIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/members/${userId}`,
      { ...axiosConfig, data: body }
    );
  }

  async postV2TeamsInviteByTeamId<
    T extends PostV2TeamsInviteByTeamIdResponse,
    D,
    C extends PostV2TeamsInviteByTeamIdBody
  >(
    body: C,
    { teamId }: PostV2TeamsInviteByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/invite`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsInvitationsResendByTeamIdAndInvitationId<
    T,
    D,
    C extends null
  >(
    body: C,
    {
      teamId,
      invitationId,
    }: PostV2TeamsInvitationsResendByTeamIdAndInvitationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/invitations/${invitationId}/resend`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsInviteAcceptPanelByInvitationId<T, D, C extends null>(
    body: C,
    { invitationId }: PostV2TeamsInviteAcceptPanelByInvitationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/invite/accept/panel/${invitationId}`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsInviteAcceptEmailByToken<T, D, C extends null>(
    body: C,
    { token }: PostV2TeamsInviteAcceptEmailByTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/invite/accept/email/${token}`,
      body,
      axiosConfig
    );
  }

  async patchV2TeamsSettingsByTeamId<
    T extends PatchV2TeamsSettingsByTeamIdResponse,
    D,
    C extends PatchV2TeamsSettingsByTeamIdBody
  >(
    body: C,
    { teamId }: PatchV2TeamsSettingsByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.patch<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/settings`,
      body,
      axiosConfig
    );
  }

  async patchV2TeamsMembersRolesByTeamId<
    T extends PatchV2TeamsMembersRolesByTeamIdResponse,
    D,
    C extends PatchV2TeamsMembersRolesByTeamIdBody
  >(
    body: C,
    { teamId }: PatchV2TeamsMembersRolesByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.patch<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/members/roles`,
      body,
      axiosConfig
    );
  }

  async getV2TeamsByTeamId<T extends GetV2TeamsByTeamIdResponse, D, C>(
    { teamId }: GetV2TeamsByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}`,
      axiosConfig
    );
  }

  async getV2TeamsSubscriptionInfoByTeamId<
    T extends GetV2TeamsSubscriptionInfoByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsSubscriptionInfoByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/subscription-info`,
      axiosConfig
    );
  }

  async getV2TeamsMembersByTeamId<
    T extends GetV2TeamsMembersByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsMembersByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/members`,
      axiosConfig
    );
  }

  async getV2TeamsInvitationsByTeamId<
    T extends GetV2TeamsInvitationsByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsInvitationsByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/invitations`,
      axiosConfig
    );
  }

  async getV2TeamsInvited<T extends GetV2TeamsInvitedResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/teams/invited',
      axiosConfig
    );
  }

  async getV2TeamsInviteValidateByToken<
    T extends GetV2TeamsInviteValidateByTokenResponse,
    D,
    C
  >(
    { token }: GetV2TeamsInviteValidateByTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/invite/validate/${token}`,
      axiosConfig
    );
  }

  async deleteV2TeamsByTeamIdAndEmail<T, D, C extends null>(
    { teamId, email }: DeleteV2TeamsByTeamIdAndEmailParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/${email}`,
      { ...axiosConfig, data: body }
    );
  }

  async deleteV2TeamsInvitationsByTeamIdAndInvitationId<T, D, C extends null>(
    {
      teamId,
      invitationId,
    }: DeleteV2TeamsInvitationsByTeamIdAndInvitationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/invitations/${invitationId}`,
      { ...axiosConfig, data: body }
    );
  }
}
